import CommonTitleBar from "components/common/CommonTitleBar";
import NoDataFound from "components/common/NoDataFound";
import Spinners from "components/common/Spinners";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllClosures } from "store/actions/closureSlice";
import ClosureCard from "./ClosureCard";
import Filters from "components/common/Filters";
import { getBranchListWithCity } from "store/actions/branchSlice";
import { closureTypes, orderByOptions } from "components/constants/StatusKeys";
import { spaceTypeOptions } from "components/constants/DropdownOptions";
import Paginations from "components/common/Paginations";
import { formatFilterOptions, getMinMaxDate } from "components/common/Utils";
import WorkshopShimmer from "components/ShimmerEffects/WorkshopShimmer";
import { getOrganistionList } from "store/actions/organizationSlice";

const Closures = () => {
  const { t } = useTranslation();
  document.title = t("Closures | Work Space");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const pageNumber = Number(new URLSearchParams(search).get("page")) || 1;

  const {
    isLoading,
    loading,
    closures,
    expiredClosures,
    perPage,
    totalCount,
    totalPages,
    currentPage,
  } = useSelector((state) => state.Closures);

  const [keyword, setKeyword] = useState(null);
  const { organisationsList } = useSelector((state) => state.Organizations);

  const [selectedFilters, setSelectedFilters] = useState({
    type: -1,
    spaceType: null,
    branches: [],
    organizationId: "",
  });
  const [dates, setDates] = useState([]);

  useEffect(() => {
    getAllData();

    const fetchBranchesWithCity = () => {
      dispatch(getBranchListWithCity());
    };
    fetchBranchesWithCity();
    dispatch(getOrganistionList());
  }, []);

  const getAllData = (page, action) => {
    const { actionType } = action || {}; // SEARCH, RESET, RESET_KEYWORD
    const { type, spaceType, branches, organizationId } = selectedFilters || [];
    const isReset = actionType === "RESET";

    const payload = {
      perPage: perPage,
      pageNo: page || pageNumber,
      status: -1,
      orderBy: -1,
      keyword: "",
      type: isReset ? -1 : type,
      spaceType: isReset ? null : spaceType,
      branches: isReset ? [] : branches || [],
      dateRange: isReset ? {} : getMinMaxDate(dates),
      organizationId: isReset ? "" : organizationId,
    };

    console.log("Payload" ,payload);
    dispatch(getAllClosures(payload));
    navigate(`/management/ws-management?page=${page || pageNumber}`);
  };

  const handleReset = () => {
    setKeyword("");

    setDates([]);
    setSelectedFilters({ type: -1, spaceType: null, branches: [] });
    getAllData(pageNumber, { actionType: "RESET" });
  };

  const filters = [
    {
      key: "type",
      placeholder: "Closure Type",
      options: closureTypes,
      type: "singleSelect",
    },
    {
      key: "spaceType",
      placeholder: "Space Type",
      options: spaceTypeOptions,
      type: "singleSelect",
    },
    {
      key: "branches",
      type: "branchCityFilter",
    },
    {
      key: "organizationId",
      placeholder: "Organization",
      options: formatFilterOptions(organisationsList),
      type: "singleSelect",
    },
  ];
  return (
    <React.Fragment>
      <div className="page-content common_page closure_page">
        <Container fluid>
          <CommonTitleBar
            title={t("WS Management")}
            isCreateBtn={true}
            createBtnText={t("Add New")}
            onCreateBtnClick={() =>
              navigate("/management/ws-management/add-new-closure")
            }
          />
          <div className="common_wrapper">
            <div className="">
              <h2 className="fs_20 mb-2">{t("Current Closures")}</h2>
              <Filters
                keyword={keyword}
                setKeyword={setKeyword}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                dates={dates}
                setDates={setDates}
                filters={filters}
                onSearch={getAllData}
                onReset={handleReset}
                className="filter_2"
              />
            </div>
            <div className="closure_row">
              {loading ? (
                <WorkshopShimmer />
              ) : closures?.length === 0 ? (
                <NoDataFound text={t("No closures found")} />
              ) : (
                closures?.map((item) => (
                  <ClosureCard
                    key={item?._id}
                    item={item}
                    isLoading={isLoading}
                  />
                ))
              )}
            </div>
          </div>

          <h2 className="fs_20 mb-2">{t("Expired Closures")}</h2>

          <div className="common_wrapper">
            <div className="closure_row">
              {loading ? (
                <WorkshopShimmer />
              ) : expiredClosures?.length === 0 ? (
                <NoDataFound text={t("No expired closures found")} />
              ) : (
                expiredClosures?.map((item) => (
                  <ClosureCard
                    key={item?._id}
                    item={item}
                    isLoading={isLoading}
                    className="draft"
                  />
                ))
              )}
            </div>
          </div>

          {!loading && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => {
                getAllData(page);
              }}
              totalCount={totalCount}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Closures;
